module.exports = __webpack_public_path__ + "static/media/redux.5dccc776.svg";